// extracted by mini-css-extract-plugin
export default {"tableHeader":"CreditTransactionList_tableHeader__NaWwH","plus":"CreditTransactionList_plus__DN-RK","minus":"CreditTransactionList_minus__6Gr2d"};